// extracted by mini-css-extract-plugin
export default {"down":"down-oTwTG","left":"left-ZbnpX","icon":"icon-aMG1h"};